import { Button } from '@kanda-libs/ks-design-library';

import { SUBMIT_BUTTON, CLASS_NAMES } from './Footer-constants';

interface ViewComponentProps {
  /**
   * Disabled state for login button
   */
  disabled?: boolean;
}

const ViewComponent = ({ disabled }: ViewComponentProps) => (
  <div className={CLASS_NAMES.container}>
    <Button.Text {...SUBMIT_BUTTON} disabled={disabled} />
  </div>
);

ViewComponent.defaultProps = {
  disabled: undefined,
};

ViewComponent.displayName = 'SSO-Footer-view';

export default ViewComponent;
